export default __webpack_public_path__ + "static/media/logo.52aa703c.png";